import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import shortDateFormat from '../../../helpers/dates';
import ActionsDropdown from '../../atoms/ActionsDropdown/ActionsDropdown';
import Icon from '../../atoms/Icon/Icon';
import './ListItem.scss';

const ListItem = ({
  imgSrc,
  name,
  code,
  dynasty,
  location,
  creationDate,
  onViewClicked,
  onEditClicked,
  onDeleteClicked,
  inReview,
}) => {
  const eventKeyBase = `${(Math.random() * 1000).toFixed(0)}`;
  const history = useHistory();
  const onActionClicked = (key) => {
    if (key === `${eventKeyBase}-view` && onViewClicked) {
      onViewClicked();
    }
    if (key === `${eventKeyBase}-edit` && onEditClicked) {
      onEditClicked();
    }
    if (key === `${eventKeyBase}-delete` && onDeleteClicked) {
      onDeleteClicked();
    }
  };
  return (
    <div className="list-item" key={`${eventKeyBase}-item`}>
      {inReview === 1 && (
        <div className="flag-container">
          <div className="review-flag" />
        </div>
      )}
      <img src={imgSrc} alt={name} className="row-img" />
      <div className="row-name">
        <span className="name" onClick={() => onActionClicked(`${eventKeyBase}-view`)}>{name}</span>
        <span className="code">{`#${code}`}</span>
      </div>
      <span className="dynasty" onClick={() => history.push('/dynasties')}>{dynasty}</span>
      <span className="location" onClick={() => history.push('/countries')}>{location}</span>
      <span className="creation-date">{shortDateFormat(creationDate)}</span>
      <div className="actions">
        <ActionsDropdown onSelect={onActionClicked}>
          <Dropdown.Item eventKey={`${eventKeyBase}-view`}>
            <div className="action-container">
              <span className="icon">
                <Icon icon="eye" color="#000" />
              </span>
              <span className="action-desc">
                View
              </span>
            </div>
          </Dropdown.Item>
          <Dropdown.Item eventKey={`${eventKeyBase}-edit`}>
            <div className="action-container">
              <span className="icon">
                <Icon icon="edit" color="#000" />
              </span>
              <span className="action-desc">
                Edit
              </span>
            </div>
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item eventKey={`${eventKeyBase}-delete`}>
            <div className="action-container">
              <span className="icon">
                <Icon icon="trash" color="#000" />
              </span>
              <span className="action-desc">
                Delete
              </span>
            </div>
          </Dropdown.Item>
        </ActionsDropdown>
      </div>
    </div>
  );
};

ListItem.propTypes = {
  imgSrc: PropTypes.string,
  name: PropTypes.string,
  code: PropTypes.string,
  dynasty: PropTypes.string,
  location: PropTypes.object,
  creationDate: PropTypes.string,
  onViewClicked: PropTypes.func,
  onEditClicked: PropTypes.func,
  onDeleteClicked: PropTypes.func,
  inReview: PropTypes.bool,
};

ListItem.defaultProps = {
  imgSrc: undefined,
  name: undefined,
  code: undefined,
  dynasty: undefined,
  location: undefined,
  creationDate: undefined,
  onViewClicked: undefined,
  onEditClicked: undefined,
  onDeleteClicked: undefined,
  inReview: false,
};

export default ListItem;
